import React from 'react';

import {
    Card,
    Table
} from 'antd';

import {
    _getMassUploadPending
} from '../../services'

import {
    ADMIN_URL
} from '../../index'

class MassUploadPending extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            massUploadPending: []
        }
    }

    render() {
        return(
            <Card
                style={{marginTop: 8}}
                title='Mass Upload Pending'>
                    {this.renderPendingTable()}
            </Card>
        )
    }

    componentDidMount() {
        _getMassUploadPending()
        .then(_data => {
            this.setState({
                massUploadPending: _data.data
            })
        })
    }



    renderPendingTable = () => {

        const { massUploadPending } = this.state
        console.log({massUploadPending})
        const columns = [{
            title: 'Mass Upload Id',
            dataIndex: '_id',
            render: (_id) => <a href={`${ADMIN_URL}/products/transfer?massUploadId=${_id}`}>{_id}</a>
        },{
            title: 'Pending Approval',
            dataIndex: 'count'
        }]

        return (
            <Table 
            dataSource={massUploadPending} 
            columns={columns} 
            size="small"
            pagination={ false } 
            />
        )
    }
}

export default MassUploadPending


// WEBPACK FOOTER //
// ./src/components/product/massupload-pending.js